import BrandTile from "./brandTile";
import {TrackingAction, TrackingFeature, TrackingFeatureLabels, TrackingFeatureStatus} from "../types";

export default class TrackingService {

    private global: OttoGlobal;

    constructor() {
        /*                                    */
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            /*                                                         */
            /*         */
            this.global.eventQBus = {
                emit: () => {
                    if (window.o_global.debug.status().activated) {
                        console.log("Tracking not available.");
                    }
                }
            }
        }

        /*                                    */
        if (!window.o_util) {
            window.o_util = {
                /*                                                         */
                /*         */
                misc: {
                    getPagecluster: () => {
                        if (window.o_global.debug.status().activated) {
                            console.log("Tracking not available.");
                        }
                        return null
                    }
                }
            }
        }
    }

    sendLoadedTracking(featureOrder: number, featureIndex: number, promoType: string, brandTiles: BrandTile[], masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingFeatures = [
            this.createBrandShoppromoFeature(featureOrder, featureIndex, brandTiles.length, "loaded", promoType, masFeatureTrackingLabels),
            ...brandTiles.map(((brandTile) => {
                return this.createBrandShoppromoTileFeature(brandTile, featureIndex, "loaded", promoType)
            }))
        ];
        this.global.eventQBus.emit('tracking.bct.addFeaturesToPageImpression', trackingFeatures);
    }

    sendScrollTrackingEvent(promoType: string, featureIndex: number, tilePositions: number[]) {
        const parentFeature = {'featureId': this.getParentFeatureId(promoType, featureIndex)}
        const tileFeatures = tilePositions.map(position => {
            return {'featureId': this.getTileFeatureId(promoType, featureIndex, position)}
        })
        this.global.eventQBus.emit('tracking.bct.submitMiniActions', [parentFeature, ...tileFeatures]);
    }

    sendClickTrackingEvent(featureOrder: number, featureIndex: number, brandTile: BrandTile, filledSlots: number, promoType: string, masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingFeatures = [
            this.createBrandShoppromoFeature(featureOrder, featureIndex, filledSlots, "clicked", promoType, masFeatureTrackingLabels),
            this.createBrandShoppromoTileFeature(brandTile, featureIndex, "clicked", promoType)
        ]
        const trackingAction: TrackingAction = {
            name: "click",
            features: trackingFeatures
        }
        const wkTrackingData = {
            "wk.promo_AttributionFeature": `${promoType}_${window.o_util.misc.getPagecluster()}`,
            "wk.promo_AttributionSource": "manual"
        }

        this.global.eventQBus.emit('tracking.bct.submitMoveAction', wkTrackingData, trackingAction);
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": promoType});
    }

    private createBrandShoppromoFeature(featureOrder: number, featureIndex: number, filledSlots: number, status: TrackingFeatureStatus, promoType: string, masFeatureTrackingLabels: TrackingFeatureLabels): TrackingFeature {
        const labels = {
            promo_Feature: ["true"],
            promo_FilledSlots: [(filledSlots).toString()],
            promo_FeatureNumber: [(featureIndex + 1).toString()]
        };
        const mergedLabels = {
            ...labels,
            ...masFeatureTrackingLabels
        }
        return {
            id: this.getParentFeatureId(promoType, featureIndex),
            name: promoType,
            position: featureOrder,
            status: status,
            labels: mergedLabels
        }
    }

    private getParentFeatureId(promoType: string, featureIndex: number) {
        return 'ft3_bspr' + this.getIdSuffix(promoType) + featureIndex;
    }

    private createBrandShoppromoTileFeature(brandTile: BrandTile, featureIndex: number, status: TrackingFeatureStatus, promoType: string): TrackingFeature {
        return {
            id: this.getTileFeatureId(promoType, featureIndex, brandTile.position),
            parentId: this.getParentFeatureId(promoType, featureIndex),
            name: promoType + "-Tile",
            position: brandTile.position,
            status: status,
            labels: {
                promo_Content: [brandTile.urlPath],
                promo_TargetPsr: [brandTile.dreson],
                promo_Source: ["manual"],
                promo_ImageId: [brandTile.imageId]
            }
        };
    }

    private getTileFeatureId(promoType: string, featureIndex: number, tilePosition: number) {
        return "ft3_bspr" + this.getIdSuffix(promoType) + featureIndex + "_tile" + tilePosition;
    }

    getIdSuffix(promoType: string) {
        return (promoType === "BrandShopPromotionLarge") ? "la" : "sm";
    }
}
